import { render, staticRenderFns } from "./supply-shortage-note.vue?vue&type=template&id=b17dd3b2&scoped=true&"
import script from "./supply-shortage-note.vue?vue&type=script&lang=js&"
export * from "./supply-shortage-note.vue?vue&type=script&lang=js&"
import style0 from "./supply-shortage-note.vue?vue&type=style&index=0&id=b17dd3b2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b17dd3b2",
  null
  
)

export default component.exports